import isEmpty from 'lodash-es/isEmpty';
import { createContext, useState, useContext, PropsWithChildren, useEffect } from 'react';
import { getCurrentWorkspaceSKU } from 'wisestep-api';
import { IWorkspaceSKUContext } from 'wisestep-base';

import { useWorkspaceContext } from '../WorkspaceContext';

export const WorkspaceSKUContext = createContext<IWorkspaceSKUContext | null>(null);

export default function WorkspaceSKUContextProvider(
  props: PropsWithChildren<IWorkspaceSKUContext | null>
) {
  const [workspaceSKU, setWorkspaceSKU] = useState<IWorkspaceSKUContext | null>(null);

  const workspace = useWorkspaceContext();

  useEffect(() => {
    (async function () {
      if (workspace?.id && isEmpty(workspaceSKU)) {
        try {
          const res = await getCurrentWorkspaceSKU(workspace.id);
          const validSKU = res.data.find((item) => new Date(item?.expiryDate) > new Date());
          const activePlan = validSKU ?? res.data[0];
          for (let i = 0; i < activePlan.workspacePlanFeatures.length; i++) {
            const workspacePlanFeatureInfo =
              activePlan.workspacePlanFeatures[i].workspacePlanFeatureInfo;
            activePlan.workspacePlanFeatures[i] = {
              ...activePlan.workspacePlanFeatures[i],
              featureCode: workspacePlanFeatureInfo.featureCode,
              bitpos: workspacePlanFeatureInfo.bitpos,
              group: workspacePlanFeatureInfo.group,
              helpText: workspacePlanFeatureInfo.helpText,
              parent: workspacePlanFeatureInfo.parent,
              title: workspacePlanFeatureInfo.title,
              type: workspacePlanFeatureInfo.type,
              valueUnit: workspacePlanFeatureInfo.valueUnit,
            };
          }
          activePlan.workspacePlan = { ...activePlan };
          setWorkspaceSKU(activePlan);
        } catch (e) {
          setWorkspaceSKU(null);
        }
      }
    })();
  }, [workspace, workspace.id, workspaceSKU]);

  return (
    <WorkspaceSKUContext.Provider value={{ ...workspaceSKU, setWorkspaceSKU }}>
      {props.children}
    </WorkspaceSKUContext.Provider>
  );
}

export function useWorkspaceSKUContext() {
  const context = useContext(WorkspaceSKUContext);
  if (!context) {
    throw new Error('useAppState must be used within the WorkspaceSKUContextProvider');
  }
  return context;
}
